import { Component } from '@angular/core';

@Component({
	selector: 'app-risk-skeleton',
	imports: [],
	templateUrl: './risk-skeleton.component.html',
	styleUrl: './risk-skeleton.component.scss',
})
export class RiskSkeletonComponent {}
